import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

const hebrewLabels = {
  name: 'איש קשר',
  phone: 'נייד',
  address: 'כתובת',
  city: 'עיר',
  notes: 'הערות',
  continue: 'המשך',
  errors: {
    fullNameRequired: 'נא להזין שם פרטי ושם משפחה',
    phoneFormat: 'נא להזין מספר נייד ישראלי בפורמט 05XXXXXXXX',
  },
};

// Validation functions
function validateFullName(name) {
  const nameParts = name.trim().split(/\s+/);
  return nameParts.length >= 2 && nameParts.every(part => part.length > 0);
}

function validateIsraeliPhone(phone) {
  const cleanPhone = phone.replace(/[\s\-\(\)]/g, '');
  const phoneRegex = /^05\d{8}$/;
  return phoneRegex.test(cleanPhone);
}

function cleanPhoneInput(phone) {
  return phone.replace(/[\s\-\(\)]/g, '');
}

const styles = theme => ({
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  formControl: {
    margin: theme.spacing(),
    width: '80%',
  },
  formLabel: {
    padding: theme.spacing(),
    paddingLeft: 0,
  },
  control: {
    marginTop: theme.spacing(4),
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
  },
});

class Shipping extends React.Component {
  state = {
    validationErrors: {
      name: false,
      phone: false,
    }
  };

  handleChange = event => {
    const { value, name, id } = event.target;
    let _value = value;
    const fieldId = id || name;

    // Real-time validation
    const validationErrors = { ...this.state.validationErrors };
    
    if (fieldId === 'name') {
      validationErrors.name = _value.trim().length > 0 && !validateFullName(_value);
    } else if (fieldId === 'phone') {
      // Clean phone input and update the value
      _value = cleanPhoneInput(_value);
      validationErrors.phone = _value.trim().length > 0 && !validateIsraeliPhone(_value);
    }

    this.setState({ validationErrors });
    this.props.onFormFieldChange(fieldId, _value);
  };

  render() {
    const { classes, personal } = this.props;
    const {
      name = personal.name,
      phone = personal.phone,
      address = '',
      city = '',
      notes = '',
    } = this.props.data;

    return (
      <div className={classes.content}>
        <FormControl component="fieldset" className={classes.formControl}>
          <TextField
            id="name"
            onChange={this.handleChange}
            label={hebrewLabels.name}
            className={classes.textField}
            value={name}
            error={this.state.validationErrors.name}
            helperText={this.state.validationErrors.name ? hebrewLabels.errors.fullNameRequired : ''}
          />
        </FormControl>

        <FormControl component="fieldset" className={classes.formControl}>
          <TextField
            id="phone"
            type="tel"
            onChange={this.handleChange}
            label={hebrewLabels.phone}
            className={classes.textField}
            value={phone}
            error={this.state.validationErrors.phone}
            helperText={this.state.validationErrors.phone ? hebrewLabels.errors.phoneFormat : ''}
            placeholder="05XXXXXXXX"
          />
        </FormControl>

        <FormControl component="fieldset" className={classes.formControl}>
          <TextField
            id="address"
            onChange={this.handleChange}
            label={hebrewLabels.address}
            className={classes.textField}
            value={address}
          />
        </FormControl>

        <FormControl component="fieldset" className={classes.formControl}>
          <TextField
            id="city"
            onChange={this.handleChange}
            label={hebrewLabels.city}
            className={classes.textField}
            value={city}
          />
        </FormControl>

        {/* <FormControl component="fieldset" className={classes.formControl}>
          <TextField
            id="notes"
            onChange={this.handleChange}
            label={hebrewLabels.notes}
            className={classes.textField}
            value={notes}
          />
        </FormControl> */}
      </div>
    );
  }
}

Shipping.propTypes = {
  classes: PropTypes.object.isRequired,
  onFormFieldChange: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  personal: PropTypes.object.isRequired,
};

export default withStyles(styles)(Shipping);
